import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import DashboardLayout from './components/Layout/DashboardLayout';
import HomeLandingView from './components/dashboard/HomeLandingView';
import DashboardView from './components/dashboard/DashboardView';

import Patients from './components/dashboard/Patients';
import Clinical from './components/dashboard/Clinical';
import Scheduler from './components/dashboard/Scheduler';
import Claims from './components/dashboard/Claims';
import Visits from './components/dashboard/Visits';
import Payments from './components/dashboard/Payments';

import Settings from './components/dashboard/Settings';
import PracticeSetting from './components/dashboard/PracticeSetting';
import Insurance from './components/dashboard/Insurance';
import UserManagement from './components/dashboard/UserManagement';
import ICDManagement from './components/dashboard/ICDManagement';
import OBGYNDataset from './components/dashboard/OBGYNDataset';
import MedicationManagement from './components/dashboard/MedicationManagement';
import ProviderManagement from './components/dashboard/ProviderManagement';
import ProcedureManagement from './components/dashboard/ProcedureManagement';
import FacilityManagement from './components/dashboard/FacilityManagement';
import PracticesManagement from './components/dashboard/PracticesManagement';
import ModuleManagement from './components/dashboard/ModuleManagement';
import CourseManagement from './components/dashboard/CourseManagement';

import ClientsReport from './components/dashboard/ClientsReport';
import CaseLoadReport from './components/dashboard/CaseLoadReport';
import VisitsReport from './components/dashboard/VisitsReport';
// Import section
import StaffSessionReport from "./components/dashboard/StaffSessionReport.jsx";
import StaffLoginHistory from "./components/dashboard/StaffLoginHistory.jsx";
import ClinicalReport from "./components/dashboard/ClinicalReport";
import MissingServices from "./components/dashboard/MissingServices";
import StaffDetailReport from "./components/dashboard/StaffDetailReport";
import ClinicalDocHistory from "./components/dashboard/ClinicalDocHistory";
import ClientCountReport from "./components/dashboard/ClientCountReport";
import AccountsReceivableReport from "./components/dashboard/AccountsReceivableReport";
import TimeOverlapReport from "./components/dashboard/TimeOverlapReport";
import PaymentListReport from "./components/dashboard/PaymentListReport";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DashboardLayout />}>
          <Route index element={<HomeLandingView />} />
          <Route path="dashboard" element={<DashboardView />} />

          <Route path="dashboard/patients" element={<Patients />} />
          <Route path="dashboard/clinical" element={<Clinical />} />
          <Route path="dashboard/scheduler" element={<Scheduler />} />
          <Route path="dashboard/claims" element={<Claims />} />
          <Route path="dashboard/visits" element={<Visits />} />
          <Route path="dashboard/payments" element={<Payments />} />

          <Route path="dashboard/settings" element={<Settings />} />
          <Route path="dashboard/settings/practice" element={<PracticeSetting />} />
          <Route path="dashboard/settings/insurance" element={<Insurance />} />
          <Route path="dashboard/settings/user" element={<UserManagement />} />
          <Route path="dashboard/settings/diagnosis/icd" element={<ICDManagement />} />
          <Route path="dashboard/settings/diagnosis/obgyn" element={<OBGYNDataset />} />
          <Route path="dashboard/settings/medicines" element={<MedicationManagement />} />
          <Route path="dashboard/settings/provider" element={<ProviderManagement />} />
          <Route path="dashboard/settings/procedure" element={<ProcedureManagement />} />
          <Route path="dashboard/settings/facilities" element={<FacilityManagement />} />
          <Route path="dashboard/settings/practices" element={<PracticesManagement />} />
          <Route path="dashboard/settings/modules" element={<ModuleManagement />} />
          <Route path="dashboard/settings/courses" element={<CourseManagement />} />

          <Route path="dashboard/reports" element={<Navigate to="/dashboard/reports/clients" replace />} />
          <Route path="dashboard/reports/clients" element={<ClientsReport />} />
          <Route path="dashboard/reports/caseload" element={<CaseLoadReport />} />
          <Route path="dashboard/reports/visits-reports" element={<VisitsReport />} />
          <Route path="dashboard/reports/staff-session" element={<StaffSessionReport />} />
          <Route path="dashboard/reports/staff-login-history" element={<StaffLoginHistory />} />
          <Route path="dashboard/reports/clinical" element={<ClinicalReport />} />
          <Route path="dashboard/reports/missing-services" element={<MissingServices />} />
          <Route path="dashboard/reports/staff-detail" element={<StaffDetailReport />} />
          <Route path="dashboard/reports/clinical-doc-history" element={<ClinicalDocHistory />} />
          <Route path="dashboard/reports/client-count" element={<ClientCountReport />} />
          <Route path="dashboard/reports/account-receivable" element={<AccountsReceivableReport />} />
          <Route path="dashboard/reports/time-overlap" element={<TimeOverlapReport />} />
          <Route path="dashboard/reports/payment-list" element={<PaymentListReport />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;